<script>import { theme } from "../stores/theme.js";
export let domain = void 0;
export let assets = "";
</script>

<span class="tlmd-domain-caption {$theme}">
	<span class="logo light"><img src={assets+'/ortelium-dark.svg'} alt="Ortelium logo" /></span><span
		class="logo dark"><img src={assets+'/ortelium-light.svg'} alt="Ortelium logo" /></span
	>{#if domain && domain.length > 0}<span class="separator">&nbsp;/&nbsp;</span><span class="domain"
			>{domain}</span
		>{/if}
</span>

<style>
	.tlmd-domain-caption {
		--domain-font-size: 32px;
		--ortelium-white: #ffffff;
		--ortelium-grey: #757d82;
		--ortelium-light-green: #a5d094;
		--ortelium-dark-green: #4daf46;
	}

	.tlmd-domain-caption {
		--separator-color: var(--ortelium-light-green);
		--domain-color: var(--ortelium-dark-green);
		--light-logo-display: inline-block;
		--dark-logo-display: none;
		--text-color: var(--base-color-onSurface-secondary);
	}

	.tlmd-domain-caption.dark {
		--separator-color: var(--ortelium-dark-green);
		--domain-color: var(--ortelium-light-green);
		--light-logo-display: none;
		--dark-logo-display: inline-block;
		--text-color: var(--base-color-primary-default);
	}
	@media print {
		.tlmd-domain-caption.dark,
		.tlmd-domain-caption {
			--separator-color: var(--ortelium-light-green);
			--domain-color: var(--ortelium-dark-green);
			--light-logo-display: inline-block;
			--dark-logo-display: none;
			--text-color: var(--base-color-onSurface-secondary);
		}
	}

	.tlmd-domain-caption {
		font-size: var(--domain-font-size);
		font-weight: bold;
		line-height: 2.8;
		white-space: nowrap;
	}
	.tlmd-domain-caption .logo {
		height: calc(var(--domain-font-size) * 1.8);
		width: calc(var(--domain-font-size) * 1.8 * 3.254166667);
	}

	.tlmd-domain-caption .logo.light {
		display: var(--light-logo-display);
	}
	.tlmd-domain-caption .logo.dark {
		display: var(--dark-logo-display);
	}
	.tlmd-domain-caption .separator {
		color: var(--separator-color);
	}
	.tlmd-domain-caption .domain {
		color: var(--domain-color);
	}
</style>
